import React, {PureComponent} from 'react'
import { Close } from '@mui/icons-material';
import Modal from '@mui/material/Modal'
import { Box } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default ({className, isOpen = false, handleCloseModal, title, children, handleConfirmation, handleCancel}) => {
  return (
    <Modal
      open={isOpen}
      onClose={() => handleCloseModal()}
    >
      <Box className={className} sx={style}>
        <div className='modal__close'><button onClick={handleCloseModal} type='button'><Close className="btn-point-events" /></button></div>
        <div>
            <h3>{title}</h3>
        </div>
        {children}
        <div className="row mt-30">
        <div className="col-md-6 col-sm-12">
          <button
            className="btn"
            onClick={handleCancel}
            onKeyDown={event => {
              if ((event.key === 'Enter' || event.key === ' ') && document.activeElement === event.target) {
                event.preventDefault()
                handleCancel()
              }
            }}
          >
            Cancel
          </button>
        </div>
        <div className="col-md-6 col-sm-12">
          <button
            className="btn btn-primary"
            onClick={handleConfirmation}
            onKeyDown={event => {
              if ((event.key === 'Enter' || event.key === ' ') && document.activeElement === event.target) {
                event.preventDefault()
                handleConfirmation()
              }
            }}
          >
            Confirm
          </button>
        </div>
      </div>
      </Box>
      
    </Modal>
  )
}
